import React from 'react';
import { 
  FaDownload, 
  FaCalendarAlt, 
  FaUsers, 
  FaChartLine, 
  FaBus, 
  FaPhone,
  FaArrowRight 
} from 'react-icons/fa';
import { ADMISSION_ROUTE, CALENDAR_ROUTE, CONTACT_ROUTE, TRANSPORT_ROUTE_ROUTE } from '../../routes/rootRoutes';
import { Link } from 'react-router-dom';

const QuickLinksSection = () => {
  const quickLinks = [
    { 
      title: "Admissions 2026", 
      icon: <FaDownload className="w-5 h-5" />, 
      bgColor: "bg-blue-50",
      link: ADMISSION_ROUTE,
      iconColor: "bg-gradient-to-r from-blue-400 to-blue-500",
      borderColor: "border-blue-100",
      description: "Apply Now"
    },
    { 
      title: "School Calendar", 
      icon: <FaCalendarAlt className="w-5 h-5" />, 
      bgColor: "bg-emerald-50",
      link: CALENDAR_ROUTE,
      iconColor: "bg-gradient-to-r from-emerald-400 to-emerald-500",
      borderColor: "border-emerald-100",
      description: "View Events"
    },
    { 
      title: "Transport Routes", 
      icon: <FaBus className="w-5 h-5" />, 
      bgColor: "bg-rose-50",
      link: TRANSPORT_ROUTE_ROUTE,
      iconColor: "bg-gradient-to-r from-rose-400 to-rose-500",
      borderColor: "border-rose-100",
      description: "Check Routes"
    },
    { 
      title: "Contact Us", 
      icon: <FaPhone className="w-5 h-5" />, 
      bgColor: "bg-indigo-50",
      link: CONTACT_ROUTE,
      iconColor: "bg-gradient-to-r from-indigo-400 to-indigo-500",
      borderColor: "border-indigo-100",
      description: "Get in Touch"
    }
  ];

  return (
    <section className="py-8 bg-white">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3 lg:grid-cols-4">
          {quickLinks.map((link, index) => (
            <Link
              key={index}
              to={link.link}
              className={`group relative p-4 rounded-lg border transition-all duration-300 hover:shadow-sm ${link.bgColor} ${link.borderColor} hover:border-gray-300`}
            >
              {/* Icon Container */}
              <div className="flex items-center justify-center mb-3">
                <div className={`p-3 rounded-lg text-white shadow-sm transition-transform duration-300 group-hover:scale-105 ${link.iconColor}`}>
                  {link.icon}
                </div>
              </div>
              
              {/* Content */}
              <div>
                <h3 className="mb-1 text-sm font-semibold text-gray-800">
                  {link.title}
                </h3>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-600">
                    {link.description}
                  </span>
                  <FaArrowRight className="w-3 h-3 text-gray-400 transition-transform group-hover:translate-x-1" />
                </div>
              </div>
              
              {/* Corner accent */}
              <div className="absolute w-2 h-2 transition-opacity duration-300 rounded-full opacity-0 top-2 right-2 group-hover:opacity-100">
                <div className="w-full h-full bg-current rounded-full opacity-20" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickLinksSection;